<section class="container-id" [class]="style" >
    <span class="message-copy"
    [ngClass]="{'message-copy-show': showCopyMessage}">{{'PUBLIC_PAGE.COPIED' | translate}} !</span>
    <button class="copy-button-element whiteColor" (click)="copy(messageToCopy)" >
        <span class="subhead"  >{{label}}</span>
        <i class="pi pi-copy icon"></i> 
        <div class="btn-overlay"></div>
    </button>
</section>